import { configureStore, isRejectedWithValue } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import userReducer from './user/userSlice';
import moderateReducer from './moderate/moderateSlice';
import profileReducer from './profile/profileSlice';
import chatReducer from './chat/chatSlice';
import appointmentReducer from './appointment/appointmentSlice';
import notificationReducer from './notification/notificationSlice';
import walletReducer from './wallet/walletSlice';
import roomReducer from './room/roomSlice';
import adminDashboardReducer from './adminDashboard/adminDashboardSlice';
import { injectStore } from '../utils/axiosConfig';

const errorHandlingMiddleware = (store) => (next) => (action) => {
	if (action.type.endsWith('/rejected') && action.payload) {
	  console.error('Error:', action.payload); // Log or handle error
	}
	return next(action);
};

const store = configureStore({
	reducer: {
		auth: authReducer,
		user: userReducer,
		moderate: moderateReducer,
		profile: profileReducer,
		chat: chatReducer,
		appointment: appointmentReducer,
		notification: notificationReducer,
		wallet: walletReducer,
		room: roomReducer,
		adminDashboard: adminDashboardReducer
	},
	middleware: (getDefaultMiddleware) =>
	getDefaultMiddleware().concat(errorHandlingMiddleware),
});

injectStore(store);

export default store;

